var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    overflow: "visible",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "helpInfo",
    stroke: "none",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-708.000000, -817.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(708.000000, 817.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "rgba(222, 255, 255, 0.5)",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "questionMarkTop",
    d: "M7.74768254,8.65936947 C7.74768254,8.33007439 7.78537294,8.07120085 7.86075374,7.88274885 C7.93613454,7.69429685 8.09483096,7.5068367 8.336843,7.3203684 C8.78119299,7.03074743 9.15115402,6.67169678 9.44672611,6.24321644 C9.74229819,5.8147361 9.89008424,5.34856536 9.89008424,4.84470422 C9.89008424,4.07105916 9.63716181,3.45908608 9.13131697,3.00878498 C8.62547212,2.55848388 7.92819972,2.33333333 7.03949975,2.33333333 C6.21427836,2.33333333 5.54477782,2.53567127 5.03099816,2.94034715 C4.51721849,3.34502303 4.26627977,3.92823238 4.278182,4.6899752 L4.29008424,4.7256819 L5.98020113,4.7256819 C5.98416854,4.388452 6.08831307,4.13255402 6.29263471,3.95798796 C6.49695636,3.78342189 6.74591137,3.69613886 7.03949975,3.69613886 C7.3965667,3.69613886 7.67130988,3.79929153 7.86372929,4.00559688 C8.05614871,4.21190223 8.15235841,4.49755579 8.15235841,4.86255756 C8.15235841,5.19185264 8.06805094,5.48940843 7.89943599,5.75522494 C7.73082104,6.02104145 7.50567049,6.26900461 7.22398434,6.49911442 C6.74392767,6.8680836 6.42355926,7.18150903 6.26287914,7.43939072 C6.10219901,7.69727241 6.01987524,8.10393199 6.01590783,8.65936947 L7.74768254,8.65936947 Z",
    fill: "rgba(222, 255, 255, 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "questionMarkBottom",
    d: "M8.04127092,10.6510096 C8.04127092,10.0900776 7.58654574,9.63535246 7.02561381,9.63535246 C6.46468189,9.63535246 6.00995671,10.0900776 6.00995671,10.6510096 C6.00995671,11.2119415 6.46468189,11.6666667 7.02561381,11.6666667 C7.58654574,11.6666667 8.04127092,11.2119415 8.04127092,10.6510096 Z",
    fill: "rgba(222, 255, 255, 0.5)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.eaace3b74c00311fd6f4c39f5a1c585d.svg";
export { ForwardRef as ReactComponent };